import React from 'react';
import { Home, PieChart, ArrowRightLeft, User, Settings, LogOut, Shield } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const AccountSidebar = ({ onLogout }: { onLogout: () => void }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { name: 'Home', icon: Home, path: '/account/dashboard' },
    { name: 'Portfolio', icon: PieChart, path: '/account/portfolio' },
    { name: 'Transactions', icon: ArrowRightLeft, path: '/account/transactions' },
    { name: 'Profile', icon: User, path: '/account/profile' },
    { name: 'Security', icon: Shield, path: '/account/security' },
  ];

  return (
    <aside className="w-64 bg-[#0b1221] border-r border-gray-800 flex flex-col hidden md:flex h-full">
      <div className="p-6 flex items-center gap-3 border-b border-gray-800">
        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center font-bold text-white">A</div>
        <span className="text-xl font-bold tracking-tight text-white">AngelAlgo</span>
      </div>
      
      <div className="flex-1 overflow-y-auto py-6 px-4 space-y-2 custom-scrollbar">
        {navItems.map((item) => {
          const isActive = currentPath === item.path;
          return (
            <Link key={item.name} to={item.path} className={`flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-all ${isActive ? 'bg-blue-600/10 text-blue-500' : 'text-gray-400 hover:bg-[#131b2c] hover:text-gray-200'}`}>
              <item.icon size={20} /> {item.name}
            </Link>
          );
        })}
      </div>

      <div className="p-4 border-t border-gray-800">
        <button onClick={onLogout} className="flex items-center gap-3 px-4 py-3 w-full text-red-400 hover:bg-red-500/10 rounded-xl font-medium transition-colors">
          <LogOut size={20} /> Logout
        </button>
      </div>
    </aside>
  );
};

export default AccountSidebar;